import React, { useState } from "react";
import "./remainderpage.css";
import { Table, Dropdown, Menu, Checkbox } from "antd";
import { BsThreeDots } from "react-icons/bs";
import CompanyDashboard from "../../companies/CompanyDashboard";

import { HiOutlineCursorClick } from "react-icons/hi";
import { MdOutlineNotificationsActive } from "react-icons/md";
import { RiExportLine } from "react-icons/ri";
import RemainderModal from "../../Survelliance audit/remainder modal/RemainderModal";
import ExportModal from "../../Survelliance audit/export modal/ExportModal";

const RemainderTablePage = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isRemainderVisible, setIsRemainderVisible] = useState(false);
  const [isExportVisible, setIsExportVisible] = useState(false);

  const handleCheckboxChange = (recordKey) => {
    setSelectedRowKeys((prevSelected) => {
      if (prevSelected.includes(recordKey)) {
        // Unselect
        return prevSelected.filter((key) => key !== recordKey);
      } else {
        // Select
        return [...prevSelected, recordKey];
      }
    });
  };


  const handleSelectAll = () => {
  const allKeys = data.map((item) => item.key);
  if (selectedRowKeys.length === allKeys.length) {
    setSelectedRowKeys([]); // Deselect all
  } else {
    setSelectedRowKeys(allKeys); // Select all
  }
};



  const renderMenu = (record) => (
    <Menu className="custom-dropdown-menu">
      <Menu.Item key="view">View</Menu.Item>
      <Menu.Item key="export">Export</Menu.Item>
      <Menu.Item key="remainder">Remainder</Menu.Item>
    </Menu>
  );

  const columns = [
    {
      title: "Company Name",
      dataIndex: "companyname",
      key: "companyname",
    },
    {
      title: "Certification Number",
      dataIndex: "certificationnumber",
      key: "certificationnumber",
    },
    {
      title: "Audit Due Date",
      dataIndex: "auditduedate",
      key: "auditduedate",
    },
    {
      title: "Days Remaining",
      dataIndex: "daysremaining",
      key: "daysremaining",
      render: (text) => {
        const days = parseInt(text, 10);

        let color = "";
        if (days <= 10) {
          color = "red";
        } else if (days <= 20) {
          color = "orange";
        } else if (days <= 30) {
          color = "green";
        } else {
          color = "purple";
        }

        return <span style={{ color, fontWeight: "bold" }}>{text}</span>;
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Dropdown
          overlay={renderMenu(record)}
          trigger={["click"]}
          placement="bottomRight"
        >
          <BsThreeDots style={{ fontSize: "20px", cursor: "pointer" }} />
        </Dropdown>
      ),
    },
    {
      title: "Select",
      key: "select",
      render: (text, record) => (
        <Checkbox
  checked={selectedRowKeys.includes(record.key)}
  onChange={() => handleCheckboxChange(record.key)}
/>
      ),
    },
  ];

  const data = [
    {
      key: "1",
      companyname: "Levon techno",
      certificationnumber: "IT Services",
      auditduedate: "2025-12-20",
      daysremaining: "30",
      email: "levon@gmail.com",
    },
    {
      key: "2",
      companyname: "Beta Solutions",
      certificationnumber: "Cloud Infra",
      auditduedate: "2025-11-01",
      daysremaining: "20",
      email: "beta@example.com",
    },
    {
      key: "3",
      companyname: "Levon techno",
      certificationnumber: "IT Services",
      auditduedate: "2025-12-20",
      daysremaining: "10",
      email: "levon@gmail.com",
    },
    {
      key: "4",
      companyname: "Beta Solutions",
      certificationnumber: "Cloud Infra",
      auditduedate: "2025-11-01",
      daysremaining: "60",
      email: "beta@example.com",
    },
    {
      key: "5",
      companyname: "Levon techno",
      certificationnumber: "IT Services",
      auditduedate: "2025-12-20",
      daysremaining: "30",
      email: "levon@gmail.com",
    },
    {
      key: "6",
      companyname: "Beta Solutions",
      certificationnumber: "Cloud Infra",
      auditduedate: "2025-11-01",
      daysremaining: "20",
      email: "beta@example.com",
    },
    {
      key: "7",
      companyname: "Levon techno",
      certificationnumber: "IT Services",
      auditduedate: "2025-12-20",
      daysremaining: "10",
      email: "levon@gmail.com",
    },
    {
      key: "8",
      companyname: "Beta Solutions",
      certificationnumber: "Cloud Infra",
      auditduedate: "2025-11-01",
      daysremaining: "55",
      email: "beta@example.com",
    },
  ];

  return (
    <div>
      <CompanyDashboard />
      <div className="remainder-page mt-5">
        <div className="remainder-table mt-3">
          <div className="d-flex justify-content-between align-items-center">
            <h1>Companies List</h1>
            <div className="d-flex align-items-center gap-3">
              <button className="surve-select-btn" onClick={handleSelectAll}>
                <HiOutlineCursorClick /> Select All
              </button>
              <button
                className="surve-remainder-btn"
                onClick={() => setIsRemainderVisible(true)}
              >
                <MdOutlineNotificationsActive /> Remainder
              </button>

              <button
                className="surve-export-btn"
                onClick={() => setIsExportVisible(true)}
              >
                <RiExportLine /> Export
              </button>
            </div>
          </div>
          <div className="mt-4">
            <Table
              columns={columns}
              dataSource={data}
              pagination={{
                pageSize: Math.ceil(data.length / 2),
                total: data.length,
                className: "custom-pagination",
              }}
              scroll={{ x: "max-content" }}
              rowKey="key"
            />
          </div>
        </div>
        <RemainderModal
          visible={isRemainderVisible}
          onClose={() => setIsRemainderVisible(false)}
        />
        <ExportModal
          visible={isExportVisible}
          onClose={() => setIsExportVisible(false)}
        />
      </div>
    </div>
  );
};

export default RemainderTablePage;
